/**
 * AT Home Tabs Rail — sekmeler + yatay ok navigasyonu
 */
(function () {
  var EDGE = 4;

  function stepSize(rail) {
    var cell = rail.querySelector('.at-tabs-rail__cell');
    if (!cell) return Math.max(220, Math.floor(rail.clientWidth * 0.8));
    var styles = window.getComputedStyle(rail);
    var gap = parseFloat(styles.columnGap || styles.gap) || 16;
    return Math.round(cell.getBoundingClientRect().width + gap);
  }

  function syncArrows(viewport) {
    if (!viewport) return;
    var rail = viewport.querySelector('[data-at-rail]');
    var prev = viewport.querySelector('[data-at-rail-prev]');
    var next = viewport.querySelector('[data-at-rail-next]');
    if (!rail || !prev || !next) return;

    var max = Math.max(0, rail.scrollWidth - rail.clientWidth);
    var canScroll = max > EDGE;
    var left = rail.scrollLeft;
    var showPrev = canScroll && left > EDGE;
    var showNext = canScroll && left < max - EDGE;

    if (showPrev) prev.removeAttribute('hidden');
    else prev.setAttribute('hidden', '');

    if (showNext) next.removeAttribute('hidden');
    else next.setAttribute('hidden', '');

    prev.setAttribute('aria-hidden', showPrev ? 'false' : 'true');
    next.setAttribute('aria-hidden', showNext ? 'false' : 'true');
    viewport.classList.toggle('has-prev', showPrev);
    viewport.classList.toggle('has-next', showNext);
  }

  function scrollRail(rail, delta) {
    // mandatory snap bazı ortamlarda scroll'u sıfırlıyordu; kısa süre kapat
    var prevSnap = rail.style.scrollSnapType;
    rail.style.scrollSnapType = 'none';
    rail.scrollLeft += delta;
    window.requestAnimationFrame(function () {
      rail.style.scrollSnapType = prevSnap;
    });
  }

  function bindRail(viewport) {
    if (!viewport || viewport.dataset.atRailBound === '1') return;
    viewport.dataset.atRailBound = '1';

    var rail = viewport.querySelector('[data-at-rail]');
    var prev = viewport.querySelector('[data-at-rail-prev]');
    var next = viewport.querySelector('[data-at-rail-next]');
    if (!rail || !prev || !next) return;

    var ticking = false;
    function requestSync() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        syncArrows(viewport);
      });
    }

    rail.addEventListener('scroll', requestSync, { passive: true });
    window.addEventListener('resize', requestSync);

    prev.addEventListener('click', function (e) {
      e.preventDefault();
      scrollRail(rail, -stepSize(rail));
      requestSync();
      window.setTimeout(function () { syncArrows(viewport); }, 120);
      window.setTimeout(function () { syncArrows(viewport); }, 360);
    });
    next.addEventListener('click', function (e) {
      e.preventDefault();
      scrollRail(rail, stepSize(rail));
      requestSync();
      window.setTimeout(function () { syncArrows(viewport); }, 120);
      window.setTimeout(function () { syncArrows(viewport); }, 360);
    });

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(requestSync);
      ro.observe(rail);
    }

    window.setTimeout(function () { syncArrows(viewport); }, 100);
    window.setTimeout(function () { syncArrows(viewport); }, 600);
    syncArrows(viewport);
  }

  function init(root) {
    if (!root) return;
    // Yeniden bağlanmaya izin ver (theme editor / soft nav)
    root.dataset.atTabsReady = '1';

    var tabs = root.querySelectorAll('[data-at-tab]');
    var panels = root.querySelectorAll('[data-at-panel]');
    if (!tabs.length || !panels.length) return;

    root.querySelectorAll('.at-tabs-rail__viewport').forEach(bindRail);

    if (root.dataset.atTabsTabsBound === '1') return;
    root.dataset.atTabsTabsBound = '1';

    function activate(name) {
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-at-tab') === name;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (panel) {
        var on = panel.getAttribute('data-at-panel') === name;
        panel.classList.toggle('is-active', on);
        if (on) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      window.requestAnimationFrame(function () {
        var active = root.querySelector('[data-at-panel].is-active .at-tabs-rail__viewport');
        syncArrows(active);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-at-tab'));
      });
      tab.addEventListener('keydown', function (e) {
        var keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (keys.indexOf(e.key) === -1) return;
        e.preventDefault();
        var list = Array.prototype.slice.call(tabs);
        var i = list.indexOf(tab);
        var nextIdx = i;
        if (e.key === 'ArrowRight') nextIdx = (i + 1) % list.length;
        if (e.key === 'ArrowLeft') nextIdx = (i - 1 + list.length) % list.length;
        if (e.key === 'Home') nextIdx = 0;
        if (e.key === 'End') nextIdx = list.length - 1;
        list[nextIdx].focus();
        activate(list[nextIdx].getAttribute('data-at-tab'));
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-at-tabs-rail]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector
      ? e.target.querySelector('[data-at-tabs-rail]')
      : null;
    if (root) {
      root.querySelectorAll('.at-tabs-rail__viewport').forEach(function (vp) {
        vp.dataset.atRailBound = '';
      });
      root.dataset.atTabsTabsBound = '';
      init(root);
    }
  });
})();
